export const ACTIONS = {
  TEST: {
    VISIT: 'test_visit',
    EDIT: 'test_edit',
  },
  VEHICLE_TRACKING: {
    INWARD: {
      VIEW: 'custom_inward_user',
      CREATE: 'custom_create_inward_vehicle_tracking',
      EDIT: 'custom_edit_inward_vehicle_tracking',
    },
    OUTWARD: {
      VIEW: 'custom_outward_user',
      CREATE: 'custom_create_outward_vehicle_tracking',
      EDIT: 'custom_edit_outward_vehicle_tracking',
      PLAN: 'custom_plan_outward_vehicle_tracking',
      VIEW_LOAD: 'custom_view_outward_vehicle_tracking_load',
      CONFIRM_LOAD: 'custom_confirm_load',
      CAPTURE_LOAD_WEIGHT_1: 'custom_capture_load_weight_1',
      CAPTURE_LOAD_WEIGHT_2: 'custom_capture_load_weight_2',
      CONFIRM_LOAD_WEIGHT: 'custom_confirm_load_weight',
      EDIT_CONFIRMED_LOAD: 'custom_edit_confirmed_load_permission',
      EDIT_DELIVERY: 'custom_edit_delivery',
      RESUME_VEHICLE_TRACKING: 'custom_resume_vehicle_tracking',
      CREATE_VEHICLE_TRACKING_ENTRY_LOG:
        'custom_create_vehicle_tracking_entry_log',
      CREATE_VEHICLE_TRACKING_EXIT_LOG:
        'custom_create_vehicle_tracking_exit_log',
      CREATE_LOAD_HEADER: 'custom_create_load_header',
      CREATE_TARGET_VS_ACTUAL: 'custom_create_target_vs_actual',
    },
    ADD: 'custom_create_vehicle_tracking',
    EDIT: 'custom_edit_vehicle_tracking_details',
    UPDATE_BASIC_DETAILS: 'custom_update_vehicle_tracking_basic_details',
    LIVE_SCREEN: 'custom_live_screen',
    EDIT_CANCEL_STATUS: 'custom_update_vehicle_tracking_cancel_status',
  },
  VEHICLE_PLANNING: {
    VIEW: 'custom_view_vehicle_planning',
    EDIT: 'custom_edit_vehicle_planning',
  },
  REPORT: {
    VEHICLE_TRACKING: 'custom_view_vehicle_tracking_report',
    VARIANCE: 'custom_view_variance_report',
    INWARD: 'custom_view_inward_report',
    GRN: 'custom_view_grn_list',
    OUTWARD: 'custom_view_outward_report',
  },
};
